module.exports = __webpack_public_path__ + "img/5.76e6b626.jpg";